import { resolveApiUrl } from "@/lib/runtime-config";
import { useClearViewer, useRequireOperator } from "@/lib/viewer";
import { Outlet } from "@tanstack/react-router";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { Header } from "./header";

export function AppShell() {
  const navigate = useNavigate();
  const viewerQuery = useRequireOperator();
  const clearViewer = useClearViewer();

  useEffect(() => {
    if (viewerQuery.data?.role === "operator") {
      return;
    }

    if (viewerQuery.isLoading) {
      return;
    }

    void navigate({ to: "/a" });
  }, [navigate, viewerQuery.data, viewerQuery.isLoading]);

  async function handleLogout() {
    await fetch(resolveApiUrl("/api/v1/auth/sign-out"), {
      method: "POST",
      credentials: "include",
    });
    clearViewer();
    await navigate({ to: "/a" });
  }

  if (viewerQuery.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 text-sm text-slate-500">
        セッションを確認しています...
      </div>
    );
  }

  if (viewerQuery.data?.role === "operator") {
    const userName = viewerQuery.data.email.split("@")[0] ?? viewerQuery.data.email;

    return (
      <div className="h-screen flex flex-col overflow-hidden">
        <Header
          mode="operator"
          userName={userName}
          userEmail={viewerQuery.data.email}
          onLogout={handleLogout}
        />
        <Outlet />
      </div>
    );
  }

  return null;
}
